<div class="meh-page">
    <div class="meh-header">
        <div>
            <p class="meh-title">Histórico de gastos de mantenimiento</p>
            <p class="meh-subtitle">Resumen de solicitudes, costos y desempeño del mantenimiento de unidades</p>
        </div>
    </div>

    <div class="meh-filter-bar">
        <div class="meh-filter-group meh-filter-group--search">
            <label>Buscar unidad (económico, placas o número de motor...)</label>
            <div class="meh-unit-search">
                <img class="meh-search-icon" src="assets/img/icons/meh-filter-search.svg" width="16" height="16" alt="">
                <input type="text" placeholder="Buscar..." [value]="unitSearchTerm" (input)="onUnitSearch($event)" (blur)="hideUnitDropdown()">
                <div class="meh-unit-dropdown" *ngIf="showUnitDropdown">
                    <button type="button" *ngFor="let u of filteredUnits" (mousedown)="selectUnit(u)">
                        {{u.unit}} <span class="meh-unit-plates">{{u.plates}}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="meh-filter-group">
            <label>Tipo de mantenimiento</label>
            <select [(ngModel)]="filterCategory" (ngModelChange)="applyFilters()">
                <option value="">Todos</option>
                <option value="Crítico en ruta">Crítico en ruta</option>
                <option value="Preventivo">Preventivo</option>
                <option value="Prog. reparación">Prog. reparación</option>
            </select>
        </div>
        <div class="meh-filter-group">
            <label>Proveedor</label>
            <select [(ngModel)]="filterSupplierId" (ngModelChange)="applyFilters()">
                <option value="">Todos</option>
                <option *ngFor="let s of suppliers" [value]="s.id">{{s.name}}</option>
            </select>
        </div>
        <button type="button" class="meh-clear-link" (click)="clearFilters()">
            <img src="assets/img/icons/meh-filter-limpiar.svg" width="16" height="16" alt="">
            Limpiar filtros
        </button>
    </div>

    <ng-container *ngIf="!selectedUnit; else unitView">
        <ng-container *ngIf="data">
            <div class="meh-kpi-row meh-kpi-row--3">
                <app-kpi-card icon="assets/img/icons/meh-kpi-gasto-total.svg" iconBg="#d4ffd9" label="Gasto total en mantenimiento" [value]="formatCurrency(data.kpis.gasto_total.value)" [changePct]="data.kpis.gasto_total.change_pct" changeTone="bad"></app-kpi-card>
                <app-kpi-card icon="assets/img/icons/meh-kpi-refacciones-stock.svg" iconBg="#d4dbff" label="Gasto en refacciones (Stock)" [value]="formatCurrency(data.kpis.gasto_refacciones_stock.value)" [changePct]="data.kpis.gasto_refacciones_stock.change_pct" changeTone="bad"></app-kpi-card>
                <app-kpi-card icon="assets/img/icons/meh-kpi-preventivo.svg" iconBg="#f2dcfc" label="Gasto en mantenimiento preventivo" [value]="formatCurrency(data.kpis.gasto_mantenimiento_preventivo.value)" [changePct]="data.kpis.gasto_mantenimiento_preventivo.change_pct" changeTone="good"></app-kpi-card>
            </div>
            <div class="meh-kpi-row meh-kpi-row--2">
                <app-kpi-card icon="assets/img/icons/meh-kpi-refacciones-solicitadas.svg" iconBg="#ffecda" label="Gasto total en refacciones (Solicitadas)" [value]="formatCurrency(data.kpis.gasto_refacciones_solicitadas.value)" [changePct]="data.kpis.gasto_refacciones_solicitadas.change_pct" changeTone="bad"></app-kpi-card>
                <app-kpi-card icon="assets/img/icons/meh-kpi-tiempo.svg" iconBg="#fee7e9" label="Tiempo promedio en mantenimiento" [value]="(data.kpis.tiempo_promedio_mantenimiento.value ?? '—') + ' Días'" [changePct]="data.kpis.tiempo_promedio_mantenimiento.change_pct" changeTone="good"></app-kpi-card>
            </div>

            <div class="meh-card">
                <p class="meh-card-title">Evolución del gasto en mantenimiento</p>
                <app-line-chart [labels]="evolutionLabels" [series]="evolutionSeries"></app-line-chart>
            </div>

            <div class="meh-card">
                <p class="meh-card-title">Desglose de gastos clave</p>
                <div class="meh-breakdown-grid">
                    <div class="meh-breakdown-card">
                        <div class="meh-breakdown-icon" style="background:#d4dbff">
                            <img src="assets/img/icons/meh-breakdown-refacciones-stock.svg" width="20" height="20" alt="">
                        </div>
                        <div>
                            <p class="meh-breakdown-label">Refacciones (Stock)</p>
                            <p class="meh-breakdown-value">{{data.expense_breakdown.refacciones_stock.count}} refacciones <img class="meh-breakdown-arrow" src="assets/img/icons/meh-breakdown-arrow.svg" width="12" height="12" alt="">{{formatCurrency(data.expense_breakdown.refacciones_stock.total)}}</p>
                            <p class="meh-breakdown-sub">Refacciones disponibles en inventario utilizadas en mantenimiento</p>
                        </div>
                    </div>
                    <div class="meh-breakdown-card">
                        <div class="meh-breakdown-icon" style="background:#f2dcfc">
                            <img src="assets/img/icons/meh-breakdown-preventivo.svg" width="20" height="20" alt="">
                        </div>
                        <div>
                            <p class="meh-breakdown-label">Mantenimiento preventivo</p>
                            <p class="meh-breakdown-value">{{data.expense_breakdown.mantenimiento_preventivo.count}} prevenciones <img class="meh-breakdown-arrow" src="assets/img/icons/meh-breakdown-arrow.svg" width="12" height="12" alt="">{{formatCurrency(data.expense_breakdown.mantenimiento_preventivo.total)}}</p>
                            <p class="meh-breakdown-sub">Servicios preventivos realizados para evitar fallas futuras</p>
                        </div>
                    </div>
                    <div class="meh-breakdown-card">
                        <div class="meh-breakdown-icon" style="background:#ffecda">
                            <img src="assets/img/icons/meh-breakdown-refacciones-solicitadas.svg" width="20" height="20" alt="">
                        </div>
                        <div>
                            <p class="meh-breakdown-label">Refacciones (Solicitadas)</p>
                            <p class="meh-breakdown-value">{{data.expense_breakdown.refacciones_solicitadas.count}} refacciones <img class="meh-breakdown-arrow" src="assets/img/icons/meh-breakdown-arrow.svg" width="12" height="12" alt="">{{formatCurrency(data.expense_breakdown.refacciones_solicitadas.total)}}</p>
                            <p class="meh-breakdown-sub">Refacciones no disponibles en inventario y solicitadas a proveedores</p>
                        </div>
                    </div>
                    <div class="meh-breakdown-card">
                        <div class="meh-breakdown-icon" style="background:#fee7e9">
                            <img src="assets/img/icons/meh-breakdown-externos.svg" width="20" height="20" alt="">
                        </div>
                        <div>
                            <p class="meh-breakdown-label">Mantenimientos externos</p>
                            <p class="meh-breakdown-value">{{data.expense_breakdown.mantenimientos_externos.count}} externos <img class="meh-breakdown-arrow" src="assets/img/icons/meh-breakdown-arrow.svg" width="12" height="12" alt="">{{formatCurrency(data.expense_breakdown.mantenimientos_externos.total)}}</p>
                            <p class="meh-breakdown-sub">Costos por mantenimientos externos requeridos</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="meh-two-col">
                <div class="meh-card">
                    <p class="meh-card-title">Tendencia mensual del gasto</p>
                    <app-line-chart [labels]="monthlyLabels" [series]="monthlySeries"></app-line-chart>
                </div>
                <div class="meh-card">
                    <p class="meh-card-title">Origen de costos de refacciones</p>
                    <app-donut-chart [slices]="data.refacciones_origin.slices" [total]="data.refacciones_origin.total"></app-donut-chart>
                </div>
            </div>

            <div class="meh-card">
                <p class="meh-card-title">Insights destacados</p>
                <div class="meh-insights-grid">
                    <div class="meh-insight-flat" style="background:#f0f2ff">
                        <div class="meh-insight-flat-header">
                            <img src="assets/img/icons/meh-insight-refacciones-stock.svg" width="28" height="28" alt="">
                            <span class="meh-insight-flat-title" style="color:#1447e6">Mayor gastos en refacciones (Stock)</span>
                        </div>
                        <p class="meh-insight-flat-value">{{data.expense_breakdown.refacciones_stock.count}} refacciones <img class="meh-breakdown-arrow" src="assets/img/icons/meh-breakdown-arrow.svg" width="12" height="12" alt="">{{formatCurrency(data.expense_breakdown.refacciones_stock.total)}}</p>
                        <p class="meh-insight-flat-sub">Refacciones disponibles en inventario utilizadas en mantenimiento</p>
                    </div>
                    <div class="meh-insight-flat" style="background:#fff7f0">
                        <div class="meh-insight-flat-header">
                            <img src="assets/img/icons/meh-insight-refacciones-solicitadas.svg" width="28" height="28" alt="">
                            <span class="meh-insight-flat-title" style="color:#fb8b25">Mayor gasto en refacciones (solicitadas)</span>
                        </div>
                        <p class="meh-insight-flat-value">{{data.expense_breakdown.refacciones_solicitadas.count}} refacciones <img class="meh-breakdown-arrow" src="assets/img/icons/meh-breakdown-arrow.svg" width="12" height="12" alt="">{{formatCurrency(data.expense_breakdown.refacciones_solicitadas.total)}}</p>
                        <p class="meh-insight-flat-sub">Refacciones no disponibles en inventario y solicitadas a proveedores</p>
                    </div>
                    <div class="meh-insight-flat" style="background:#faf1fe">
                        <div class="meh-insight-flat-header">
                            <img src="assets/img/icons/meh-insight-preventivo.svg" width="28" height="28" alt="">
                            <span class="meh-insight-flat-title" style="color:#7f43d7">Mayor gasto en preventivo</span>
                        </div>
                        <p class="meh-insight-flat-value">{{data.expense_breakdown.mantenimiento_preventivo.count}} prevenciones <img class="meh-breakdown-arrow" src="assets/img/icons/meh-breakdown-arrow.svg" width="12" height="12" alt="">{{formatCurrency(data.expense_breakdown.mantenimiento_preventivo.total)}}</p>
                        <p class="meh-insight-flat-sub">Servicios preventivos realizados para evitar fallas futuras</p>
                    </div>
                    <div class="meh-insight-flat" style="background:#f4fbf4">
                        <div class="meh-insight-flat-header">
                            <img src="assets/img/icons/meh-insight-unidad-mayor-gasto.svg" width="28" height="28" alt="">
                            <span class="meh-insight-flat-title" style="color:#00a63e">Unidad con mayor gasto total</span>
                        </div>
                        <p class="meh-insight-flat-value">{{data.top_unit.unit_name || '—'}} <img class="meh-breakdown-arrow" src="assets/img/icons/meh-breakdown-arrow.svg" width="12" height="12" alt="">{{formatCurrency(data.top_unit.total)}}</p>
                        <p class="meh-insight-flat-sub">Unidad que acumula el mayor gasto de mantenimiento en el periodo</p>
                    </div>
                </div>
            </div>

            <div class="meh-card meh-table-card">
                <p class="meh-card-title meh-card-title--padded">Detalle de solicitudes de mantenimiento</p>
                <div class="meh-table-filter-bar">
                    <select [(ngModel)]="tableFailureId" (ngModelChange)="applyFilters()">
                        <option value="">Tipo de falla</option>
                        <option *ngFor="let f of failures" [value]="f.id">{{f.name}}</option>
                    </select>
                    <select [(ngModel)]="tableUnitId" (ngModelChange)="applyFilters()">
                        <option value="">Unidad</option>
                        <option *ngFor="let u of units" [value]="u.id">{{u.unit}}</option>
                    </select>
                    <input type="text" placeholder="Buscar por folio o unidad..." [(ngModel)]="tableSearch" (ngModelChange)="applyFilters()">
                </div>
                <div class="meh-table-scroll">
                    <table class="meh-full-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Folio</th>
                                <th>Fecha solicitud</th>
                                <th>Unidad</th>
                                <th>Tipo mantenimiento</th>
                                <th>Refacciones</th>
                                <th>Estado</th>
                                <th>Costo total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data.requests_table.data; let i = index">
                                <td>{{(currentPage - 1) * perPage + i + 1}}</td>
                                <td>{{row.folio}}</td>
                                <td>{{formatDate(row.date)}}</td>
                                <td>{{row.unit}}</td>
                                <td><span class="meh-pill" [ngClass]="tipoPillClass(row.tipo_mantenimiento)">{{row.tipo_mantenimiento || '—'}}</span></td>
                                <td><span class="meh-pill" [ngClass]="row.refacciones === 'Inventario' ? 'meh-pill--refacciones-inventario' : (row.refacciones === 'Solicitado' ? 'meh-pill--refacciones-solicitado' : '')" *ngIf="row.refacciones !== '—'; else noRefaccion">{{row.refacciones}}</span><ng-template #noRefaccion>—</ng-template></td>
                                <td><span class="meh-pill" [ngClass]="'meh-pill--estado-' + row.status_tone">{{row.status_label}}</span></td>
                                <td>{{formatCurrency(row.cost_total)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="meh-pagination-bar" *ngIf="data.requests_table.pagination.total > 0">
                    <span>Mostrando {{(currentPage - 1) * perPage + 1}} a {{Math.min(currentPage * perPage, data.requests_table.pagination.total)}} de {{data.requests_table.pagination.total}} gastos</span>
                    <div class="meh-pagination" *ngIf="data.requests_table.pagination.last_page > 1">
                        <button type="button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">‹</button>
                        <button type="button" *ngFor="let p of pageNumbers" [class.active]="p === currentPage" (click)="goToPage(p)">{{p}}</button>
                        <button type="button" [disabled]="currentPage === data.requests_table.pagination.last_page" (click)="goToPage(currentPage + 1)">›</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #unitView>
        <ng-container *ngIf="unitData">
            <div class="meh-card meh-unit-outer-card">
            <div class="meh-unit-top-grid">
                <div class="meh-unit-info-card">
                    <img class="meh-unit-photo" src="assets/img/icons/meh-unit-vehicle-placeholder.png" alt="Foto de la unidad">
                    <div class="meh-unit-info-grid">
                        <p class="meh-unit-info-line"><span class="meh-unit-info-label">Unidad:</span> <span class="meh-unit-info-value">{{unitData.unit.unit || 'N/A'}}</span></p>
                        <p class="meh-unit-info-line"><span class="meh-unit-info-label">Marca/Modelo:</span> <span class="meh-unit-info-value">N/A</span></p>
                        <p class="meh-unit-info-line"><span class="meh-unit-info-label">Tipo:</span> <span class="meh-unit-info-value">{{unitData.unit.type || 'N/A'}}</span></p>
                        <p class="meh-unit-info-line"><span class="meh-unit-info-label">Placas:</span> <span class="meh-unit-info-value">{{unitData.unit.plates || 'N/A'}}</span></p>
                        <p class="meh-unit-info-line"><span class="meh-unit-info-label">Kilometraje actual:</span> <span class="meh-unit-info-value">{{unitData.unit.current_km !== null ? formatKm(unitData.unit.current_km) : 'N/A'}}</span></p>
                        <div class="meh-unit-info-line">
                            <span class="meh-unit-info-label">Estatus:</span>
                            <span class="meh-unit-status-pill" [class.meh-unit-status-pill--inactive]="!unitData.unit.active">{{unitData.unit.active ? 'Activo' : 'Inactivo'}}</span>
                        </div>
                    </div>
                </div>

                <div class="meh-unit-stats-col">
                    <div class="meh-unit-total-card">
                        <p class="meh-plain-stat-label meh-plain-stat-label--upper">Gasto acumulado de la unidad</p>
                        <p class="meh-plain-stat-value">{{formatCurrency(unitData.spend_split.gasto_acumulado)}} <span class="meh-currency-suffix">MXN</span></p>
                        <p class="meh-unit-total-change" *ngIf="unitData.spend_split.gasto_acumulado_change_pct !== null">
                            <span [class.meh-change-bad]="unitData.spend_split.gasto_acumulado_change_pct >= 0" [class.meh-change-good]="unitData.spend_split.gasto_acumulado_change_pct < 0">
                                {{unitData.spend_split.gasto_acumulado_change_pct >= 0 ? '▲' : '▼'}} {{unitData.spend_split.gasto_acumulado_change_pct}}%
                            </span>
                            vs. periodo anterior
                        </p>
                    </div>
                    <div class="meh-unit-stats-row">
                        <div class="meh-unit-mini-stat">
                            <div class="meh-unit-mini-icon" style="background:#eff6ff">
                                <img src="assets/img/icons/meh-unit-ministat-refacciones.svg" width="20" height="20" alt="">
                            </div>
                            <div>
                                <p class="meh-plain-stat-label">Refacciones</p>
                                <p class="meh-unit-mini-value">{{formatCurrency(unitData.spend_split.refacciones_total)}}</p>
                                <p class="meh-unit-mini-pct">{{spendPct(unitData.spend_split.refacciones_total, unitData.spend_split.gasto_acumulado)}}%</p>
                            </div>
                        </div>
                        <div class="meh-unit-mini-stat">
                            <div class="meh-unit-mini-icon" style="background:#fef3c7">
                                <img src="assets/img/icons/meh-unit-ministat-labor.svg" width="20" height="20" alt="">
                            </div>
                            <div>
                                <p class="meh-plain-stat-label">Mano de obra</p>
                                <p class="meh-unit-mini-value">{{formatCurrency(unitData.spend_split.mano_obra_total)}}</p>
                                <p class="meh-unit-mini-pct">{{spendPct(unitData.spend_split.mano_obra_total, unitData.spend_split.gasto_acumulado)}}%</p>
                            </div>
                        </div>
                    </div>
                    <div class="meh-unit-count-card">
                        <div class="meh-unit-mini-icon" style="background:#e0f2fe">
                            <img src="assets/img/icons/meh-unit-ministat-count.svg" width="20" height="20" alt="">
                        </div>
                        <div>
                            <p class="meh-plain-stat-label">N.º mantenimientos</p>
                            <p class="meh-unit-mini-value">{{unitData.spend_split.n_mantenimientos}}</p>
                            <p class="meh-unit-mini-pct">Total realizados</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="meh-insights-grid meh-insights-grid--2col">
                <div class="meh-insight" *ngIf="unitData.insights.ultimo">
                    <div class="meh-insight-icon" style="background:#dcfce7">
                        <img src="assets/img/icons/meh-unit-insight-ultimo.svg" width="20" height="20" alt="">
                    </div>
                    <div>
                        <p class="meh-insight-label">Último mantenimiento realizado</p>
                        <p class="meh-insight-value">{{unitData.insights.ultimo.label}}</p>
                        <div class="meh-insight-facts">
                            <span><strong>Fecha:</strong> {{formatDateLong(unitData.insights.ultimo.date)}}</span>
                            <span><strong>Kilometraje:</strong> {{formatKm(unitData.insights.ultimo.km)}}</span>
                        </div>
                        <div class="meh-insight-facts">
                            <span><strong>Costo:</strong> {{formatCurrency(unitData.insights.ultimo.cost)}}</span>
                            <span *ngIf="unitData.insights.ultimo.supplier"><strong>Proveedor:</strong> {{unitData.insights.ultimo.supplier}}</span>
                        </div>
                    </div>
                </div>
                <div class="meh-insight" *ngIf="unitData.insights.proximo">
                    <div class="meh-insight-icon" style="background:#fef9c2">
                        <img src="assets/img/icons/meh-unit-insight-proximo.svg" width="20" height="20" alt="">
                    </div>
                    <div>
                        <div class="meh-insight-header">
                            <p class="meh-insight-label">Próximo mantenimiento programado</p>
                            <span class="meh-badge-proximo">Próximo</span>
                        </div>
                        <p class="meh-insight-value">A los {{formatKm(unitData.insights.proximo.target_km)}}</p>
                        <div class="meh-insight-facts">
                            <span *ngIf="unitData.insights.proximo.remaining_km !== null"><strong>Faltan:</strong> {{formatKm(unitData.insights.proximo.remaining_km)}}</span>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <div class="meh-two-col">
                <div class="meh-card">
                    <p class="meh-card-title">Mano de obra</p>
                    <p class="meh-panel-sub">Total gastado en mano de obra</p>
                    <p class="meh-panel-total">{{formatCurrency(unitData.labor_by_provider.total)}}</p>
                    <p class="meh-panel-count">{{unitData.spend_split.n_mantenimientos}} servicios de mano de obra</p>
                    <div class="meh-provider-list">
                        <p class="meh-provider-list-title">GASTO POR PROVEEDOR</p>
                        <div class="meh-provider-row" *ngFor="let r of visibleLaborRows">
                            <span>{{r.supplier_name}}</span>
                            <strong>{{formatCurrency(r.total)}}</strong>
                        </div>
                    </div>
                    <button type="button" class="meh-ver-todas" *ngIf="unitData.labor_by_provider.rows.length > 4" (click)="laborExpanded = !laborExpanded">
                        {{laborExpanded ? 'Ver menos' : 'Ver todas las manos de obra'}}
                        <img src="assets/img/icons/meh-unit-link-arrow.svg" width="12" height="12" alt="">
                    </button>
                </div>
                <div class="meh-card">
                    <p class="meh-card-title">Refacciones</p>
                    <p class="meh-panel-sub">Total gastado en refacciones</p>
                    <p class="meh-panel-total">{{formatCurrency(unitData.refacciones_by_part.total)}}</p>
                    <p class="meh-panel-count">{{unitData.refacciones_by_part.rows.length}} refacciones utilizadas</p>
                    <div class="meh-provider-list">
                        <div class="meh-provider-row meh-provider-row--stacked" *ngFor="let r of visiblePartsRows">
                            <span>
                                <strong class="meh-part-name">{{r.part_name}}</strong>
                                <small class="meh-part-qty">{{r.quantity}} unidades</small>
                            </span>
                            <strong>{{formatCurrency(r.total)}}</strong>
                        </div>
                    </div>
                    <button type="button" class="meh-ver-todas" *ngIf="unitData.refacciones_by_part.rows.length > 4" (click)="partsExpanded = !partsExpanded">
                        {{partsExpanded ? 'Ver menos' : 'Ver todas las refacciones'}}
                        <img src="assets/img/icons/meh-unit-link-arrow.svg" width="12" height="12" alt="">
                    </button>
                </div>
            </div>

            <div class="meh-card">
                <p class="meh-card-title">Proveedores</p>
                <p class="meh-panel-sub">Gasto total por proveedor (refacciones + mano de obra)</p>
                <div class="meh-table-scroll">
                    <table class="meh-full-table meh-providers-table">
                        <thead>
                            <tr><th>Proveedor</th><th>Refacciones</th><th>M. de Obra</th><th>Total</th></tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let p of visibleProveedores">
                                <td>{{p.supplier_name}}</td>
                                <td>{{formatCurrency(p.refacciones_total)}}</td>
                                <td>{{formatCurrency(p.mano_obra_total)}}</td>
                                <td>{{formatCurrency(p.total)}}</td>
                            </tr>
                            <tr class="meh-providers-total-row" *ngIf="unitData.proveedores.length">
                                <td>Total</td>
                                <td>{{formatCurrency(proveedoresTotal.refacciones_total)}}</td>
                                <td>{{formatCurrency(proveedoresTotal.mano_obra_total)}}</td>
                                <td>{{formatCurrency(proveedoresTotal.total)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button type="button" class="meh-ver-todas meh-ver-todas--padded" *ngIf="unitData.proveedores.length > 4" (click)="proveedoresExpanded = !proveedoresExpanded">
                    {{proveedoresExpanded ? 'Ver menos' : 'Ver todos los proveedores'}}
                    <img src="assets/img/icons/meh-unit-link-arrow.svg" width="12" height="12" alt="">
                </button>
            </div>

            <div class="meh-card meh-table-card">
                <div class="meh-history-header">
                    <p class="meh-card-title">Historial de mantenimiento</p>
                    <div class="meh-unit-history-search">
                        <img src="assets/img/icons/meh-unit-table-search.svg" width="14" height="14" alt="">
                        <input type="text" placeholder="Buscar en historial..." [(ngModel)]="unitHistorySearch" (ngModelChange)="onUnitHistorySearch()">
                    </div>
                </div>
                <div class="meh-tabs meh-tabs--history">
                    <button type="button" [class.active]="historyTab === 'Todos'" (click)="setHistoryTab('Todos')">Todos</button>
                    <button type="button" [class.active]="historyTab === 'Preventivo'" (click)="setHistoryTab('Preventivo')">Preventivos</button>
                    <button type="button" [class.active]="historyTab === 'Correctivo'" (click)="setHistoryTab('Correctivo')">Correctivos</button>
                </div>
                <div class="meh-table-scroll">
                    <table class="meh-full-table meh-history-table">
                        <thead>
                            <tr><th>Fecha</th><th>Tipo</th><th>Proveedor</th><th>Refacciones</th><th>M. de Obra</th><th>Total</th><th>Estado</th><th></th></tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let row of unitData.history.data">
                                <tr class="meh-row-clickable" (click)="toggleExpanded(row.id)">
                                    <td>{{formatDate(row.date)}}</td>
                                    <td><span class="meh-pill meh-pill--sm" [ngClass]="categoryPillClass(row.category)">{{row.category}}</span></td>
                                    <td>{{row.supplier}}</td>
                                    <td>{{formatCurrency(row.parts_total + row.repair_total)}}</td>
                                    <td>{{formatCurrency(row.labor_cost)}}</td>
                                    <td>{{formatCurrency(row.cost_total)}}</td>
                                    <td><span class="meh-pill meh-pill--sm" [ngClass]="'meh-pill--estado-' + row.status_tone">{{historyStatusLabel(row.status_tone)}}</span></td>
                                    <td><img class="meh-expand-caret" [class.open]="expandedRequestId === row.id" src="assets/img/icons/meh-expand-chevron.svg" width="16" height="16" alt=""></td>
                                </tr>
                                <tr class="meh-row-detail" *ngIf="expandedRequestId === row.id">
                                    <td colspan="8">
                                        <p class="meh-detail-title">Orden / Folio: <strong>MTTO-{{row.id}}</strong></p>
                                        <p class="meh-detail-section-label">DETALLE DEL SERVICIO</p>
                                        <div class="meh-detail-grid">
                                            <div>
                                                <p class="meh-detail-subtitle">Descripción</p>
                                                <p class="meh-detail-text">{{row.description}}</p>
                                            </div>
                                            <div>
                                                <p class="meh-detail-subtitle">Observaciones</p>
                                                <p class="meh-detail-text">{{row.observaciones}}</p>
                                            </div>
                                        </div>
                                        <div class="meh-detail-grid meh-detail-grid--tables">
                                            <div>
                                                <p class="meh-detail-section-label">REFACCIONES UTILIZADAS</p>
                                                <table class="meh-detail-table">
                                                    <thead>
                                                        <tr><th>Refacción</th><th>Cant.</th><th>Precio Unit.</th><th>Total</th></tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let m of row.detail.materials">
                                                            <td>{{m.part_name}}</td>
                                                            <td>{{m.quantity}}</td>
                                                            <td>{{formatCurrency(m.unit_price)}}</td>
                                                            <td>{{formatCurrency(m.total)}}</td>
                                                        </tr>
                                                        <tr *ngFor="let r of row.detail.repairs">
                                                            <td>{{r.part_name}}</td>
                                                            <td>{{r.quantity}}</td>
                                                            <td>{{formatCurrency(r.unit_price)}}</td>
                                                            <td>{{formatCurrency(r.total)}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colspan="3">Total refacciones</td>
                                                            <td>{{formatCurrency(row.parts_total + row.repair_total)}}</td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                                <p class="meh-detail-empty" *ngIf="!row.detail.materials.length && !row.detail.repairs.length">Sin refacciones registradas</p>
                                            </div>
                                            <div>
                                                <p class="meh-detail-section-label">MANO DE OBRA</p>
                                                <table class="meh-detail-table">
                                                    <thead>
                                                        <tr><th>Concepto</th><th>Horas</th><th>Costo</th></tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let l of row.detail.labor">
                                                            <td>{{l.concept}}</td>
                                                            <td>—</td>
                                                            <td>{{formatCurrency(l.cost)}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot *ngIf="row.detail.labor.length">
                                                        <tr>
                                                            <td colspan="2">Total mano de obra</td>
                                                            <td>{{formatCurrency(row.labor_cost)}}</td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                                <p class="meh-detail-empty" *ngIf="!row.detail.labor.length">Sin mano de obra registrada</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
                <div class="meh-pagination-bar" *ngIf="unitData.history.pagination.total > 0">
                    <div class="meh-page-size">
                        <span>Filas por página:</span>
                        <select [(ngModel)]="unitPerPage" (ngModelChange)="onUnitPageSizeChange()">
                            <option *ngFor="let size of unitPageSizeOptions" [ngValue]="size">{{size}}</option>
                        </select>
                    </div>
                    <div class="meh-pagination" *ngIf="unitData.history.pagination.last_page > 1">
                        <button type="button" [disabled]="unitCurrentPage === 1" (click)="unitGoToPage(unitCurrentPage - 1)">‹</button>
                        <button type="button" *ngFor="let p of unitPageNumbers" [class.active]="p === unitCurrentPage" (click)="unitGoToPage(p)">{{p}}</button>
                        <button type="button" [disabled]="unitCurrentPage === unitData.history.pagination.last_page" (click)="unitGoToPage(unitCurrentPage + 1)">›</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-template>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
